import type { WithId } from '@medplum/core';
import type { Encounter } from '@medplum/fhirtypes';
import { useTranslation } from 'react-i18next';
import { EncountersSummary } from './EncountersSummary';
import type { PromotionStatus } from './RecordListItem';

export type EncountersListProps = {
  encounters: WithId<Encounter>[];
  onSelectEncounter?: (encounterId: string) => void;
  selectedEncounterId?: string;
  onPromotionClick?: (id: string) => void;
  getPromotionStatus?: (id: string) => PromotionStatus;
};

export const EncountersList = ({
  encounters,
  onSelectEncounter,
  selectedEncounterId,
  onPromotionClick,
  getPromotionStatus,
}: EncountersListProps): React.ReactElement => {
  const { t } = useTranslation('records');

  return (
    <div className="mx-auto w-full max-w-4xl">
      {encounters.length > 0 ? (
        <EncountersSummary
          encounters={encounters}
          onSelectEncounter={onSelectEncounter}
          selectedEncounterId={selectedEncounterId}
          onPromotionClick={onPromotionClick}
          getPromotionStatus={getPromotionStatus}
        />
      ) : (
        <p className="py-8 text-center text-sm text-muted-foreground">{t('noEncountersFound')}</p>
      )}
    </div>
  );
};
